<script>
import ViewTitle from '@/components/ViewTitle'
import FloatingLabelTextInput from '@/components/FloatingLabelTextInput'
import Button from '@/components/Button'
import TimePicker from '@/components/TimePicker'
import FieldsValidator from '@/components/FieldsValidator'
import LocalStorageUtils from '@/utils/localStorageUtils'

export default
{
    name: 'new-covid-certificate',

    render () 
    {
        return (
            <div id='new-covid-certificate-view'>
                <view-title>Nouvelle attestation de déplacement automatique</view-title>
                <fields-validator ref='fieldsValidator'>
                    <floating-label-text-input validation='not-empty' placeholder='Nom' v-model={this.user.lastName} value={this.lastCertCreated.lastName} />
                    <floating-label-text-input validation='not-empty' placeholder='Prénom' v-model={this.user.firstName} />
                    <floating-label-text-input validation='not-empty' placeholder='Date de naissance' ref='birthDateInput' v-model={this.user.birthDate} />
                    <floating-label-text-input validation='not-empty' placeholder='Lieu de naissance' v-model={this.user.birthPlace} />
                    <floating-label-text-input validation='not-empty' placeholder='Adresse' v-model={this.user.address} value={this.lastCertCreated.address} />
                    <floating-label-text-input validation='not-empty' placeholder='Ville' v-model={this.user.city} value={this.lastCertCreated.city} />
                    <floating-label-text-input validation='number' placeholder='Code postal' type='tel'
                        v-model={this.user.zipcode} value={this.lastCertCreated.zipcode} />
                </fields-validator>
                <Button text='Continuer' on-click={this.onContinueButtonClicked} />
                <div class='tip'>
                    <inline-svg class='icon' src={require('@/assets/img/wind-blowing-leaves.svg')} />
                    <div class='text'>
                        Nous ne collectons aucune de ces informations, elles restent sur votre appareil seulement.
                    </div>
                </div>

                <time-picker ref='timePicker' format='DD/MM/YYYY' style={{display: 'none'}} default={{year: 1980}} />
            </div>
        )
    },

    data () 
    {
        return {
            user:
            {
                lastName: '',
                firstName: '',
                birthDate: '',
                birthPlace: '',
                address: '',
                city: '',
                zipcode: '',
            }
        }
    },

    computed:
    {
        lastCertCreated ()
        {
            return LocalStorageUtils.covidCertificateTemplates[0] || this.user
        }
    },

    mounted ()
    {
        this.$refs.timePicker.bindToInput(this.$refs.birthDateInput.$el.querySelector('input'))
    },

    methods:
    {
        onContinueButtonClicked ()
        {
            if (!this.$refs.fieldsValidator.validate()) return

            this.user.lastName = this.user.lastName.toUpperCase()
            this.user

            LocalStorageUtils.covidCertificateTemplates = [...LocalStorageUtils.covidCertificateTemplates, this.user]
            this.$router.push({ path: '/covid/certificates/generate', query: {user: JSON.stringify(this.user)} })
        }
    },

    components:
    {
        ViewTitle,
        FloatingLabelTextInput,
        TimePicker,
        FieldsValidator,
        Button
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#new-covid-certificate-view
{
    display: flex;
    flex-direction: column;
    margin: 0 10px;
    margin-bottom: calc(var(--theme-horizontal-menu-height) + 2vh);

    .OnDesktop({
        margin-top: 4vw;
        margin-left: 10vw;
        margin-right: 10vw;
        border-left: var(--theme-vertical-menu-total-vertical-space) solid transparent;
    });

    .view-title
    {
        margin-right: 0;
    }

    .floating-label-text-input
    {
        margin-top: 10px;
    }

    .button
    {
        margin-top: 20px;
        width: -webkit-fill-available;
    }

    .tip
    {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-top: 20px;
        background-color: var(--theme-background-color-success);
        color: var(--theme-text-color-success);
        border: 1px solid var(--theme-border-color-success);
        padding: 20px;
        border-radius: 6px;

        .icon
        {
            width: 100px;
            height: auto;

            .OnDesktop({ width: 40px; });
        }

        .text
        {
            margin-left: 20px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/NewCovidCertificate.vue